// extracted by mini-css-extract-plugin
module.exports = {"title":"_3becfd3c","itemStatus":"_1fce2bd","statusContainer":"_91122b4f","iconContainer":"_36e55df0","icon":"_8b8feb7"};